import MPasswordInput from './MPasswordInput.vue';

MPasswordInput.install = (app) => {
  app.component('MPasswordInput', MPasswordInput);
};

export { MPasswordInput };
